<div class="restriction-container" *ngIf="isAccessRestricted">
    <div class="row justify-content-center mt-5">
        <div class="col-md-8">
            <div class="col-12 card restriction-card p-5 text-center d-flex">
                <div class="d-flex row">
                    <mat-icon class=" col-12 restriction-icon"
                        style="font-size: 64px; height: 64px; width: 64px; color: #7200c8;">lock_clock</mat-icon>
                    <h2 class="col-12 restriction_title mt-3">Access Restricted</h2>
                </div>
                <p class="restriction_message mt-4">
                    You cannot access this service from the <strong>23rd</strong> to <strong>end of the
                        month.</strong>
                </p>
  
            </div>
        </div>
    </div>
</div>

<div class="tablecontainer container  my-4" *ngIf="!isAccessRestricted">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Account Transfer(Existing Users) </span>
        </div>

    </div>

    <div class="col-12 card card_content d-flex">
        <div class="mb-3">
            <app-button (refreshClicked)="refresh()"></app-button>
        </div>
        <div class="row ">

            <div class="col-6 pl-3 d-flex justify-content-center">
                <!-- <span class="mb-1" style="font-weight: 500;">Search Application</span> -->
                <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'"
                    style="margin-bottom: 1rem !important;">
                    <mat-label>Search</mat-label>
                    <div class="search-input-container">
                        <input matInput placeholder="Enter Application/Customer Reference Number" id="search"
                            type="text" [(ngModel)]="applicationSearchQuery"
                            (keypress)="checkIfEnter($event, 'application')"
                            (keydown.space)="preventLeadingSpace($event)"
                            (input)="restrictSpecialChars($event, 'applicationSearchQuery')">
                    </div>
                </mat-form-field>
                <button type="button" matSuffix mat-icon-button aria-label="Search"
                    class="badge bg-light-blue image-button" (click)="applicationSearch()">
                    <mat-icon style="color: white !important">search</mat-icon>
                </button>
            </div>

            <div class="col-6 pl-3 d-flex justify-content-center">
                <!-- <span class="mb-1" style="font-weight: 500;">Search Customer</span> -->
                <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'"
                    style="margin-bottom: 1rem !important;">
                    <mat-label>Search</mat-label>
                    <div class="search-input-container">
                        <input matInput placeholder="Enter Customer Reference Number" id="search" type="text"
                            [(ngModel)]="customerSearchQuery" (keypress)="checkIfEnter($event, 'customer')"
                            (keydown.space)="preventLeadingSpace($event)"
                            (input)="restrictSpecialChars($event, 'customerSearchQuery')">
                    </div>
                </mat-form-field>
                <button type="button" matSuffix mat-icon-button aria-label="Search"
                    class="badge bg-light-blue image-button" (click)="customerSearch()">
                    <mat-icon style="color: white;">search</mat-icon>
                </button>
            </div>

            <div class="col-6 card card_content align d-flex search-result-container" *ngIf="application.length > 0">
                <span style="font-size: 16px; ">Select Applications</span>
                <div class="application-search-grid mt-2" *ngIf="application.length > 0">
                    <div *ngFor="let app of application"
                        class="application-search-item d-flex flex-column align-items-start"
                        [class.selected]="isSelected(app)" (click)="toggleSelection(app)">
                        <div class="d-flex justify-content-start w-100">
                            <mat-checkbox [checked]="isSelected(app)" (change)="toggleSelection(app)"
                                (click)="$event.stopPropagation()">
                            </mat-checkbox>
                            <div class="ml-2" style="font-size: 16px; font-weight: 600;">{{ app.appRefNo }}</div>
                            <div class="mt-1 ml-auto" style="color: #9802D9 ;">{{app.serviceProviderName}}</div>
                        </div>
                        <div style="font-family: 13px; color: #23c00a;">{{app.firstName}} {{app.lastName}}</div>
                        <div style="font-family: 13px;">{{app.address1}} {{app.address2}} {{app.city}}</div>
                    </div>
                </div>
            </div>

            <div class="col-6 card card_content align d-flex search-result-container" style="margin-left: 25px;"
                *ngIf="customerData">
                <span style=" font-size: 16px;">Selected User</span>
                <div>
                    <div class="selected-user-box d-flex flex-column align-items-start">
                        <div class="d-flex justify-content-center">
                            <mat-icon
                                style="font-size: 20px; height: 20px; width: 20px; color: #7200c8; margin-top: 2px;">
                                account_circle
                            </mat-icon>
                            <div class="customer">
                                {{ customerData?.firstName }} {{ customerData?.lastName }}
                            </div>
                        </div>
                        <div class="customer">
                            {{ customerData?.email }}
                        </div>
                         <div class="customer">
                            {{ customerData?.mobileNo }}
                        </div>
                    </div>
                </div>

            </div>

            <div class="col-11 mt-3 card card_content summary d-flex search-result-container"
                *ngIf="selectedApplications.length > 0 || customerData">
                <span style=" font-size: 16px;">Transfer Summary</span>
                <div class="table-responsive mt-2 mb-4">
                    <mat-table #table [dataSource]="dataSource">

                        <ng-container matColumnDef="Application">
                            <mat-header-cell *matHeaderCellDef>Application</mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element.Application}} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Transfer from">
                            <mat-header-cell *matHeaderCellDef>Transfer from</mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element['Transfer from']}} </mat-cell>
                        </ng-container>

                        <ng-container matColumnDef="Transfer to">
                            <mat-header-cell *matHeaderCellDef>Transfer to</mat-header-cell>
                            <mat-cell *matCellDef="let element"> {{element['Transfer to']}} </mat-cell>
                        </ng-container>

                        <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
                    </mat-table>
                    <div *ngIf="dataSource.data.length == 0" class="no-data-message">
                        <p>No data found</p>
                    </div>
                </div>

                <div class="d-flex justify-content-end mb-3 mr-3">
                    <button mat-raised-button color="primary" class="btn btn-primary submit-btn" (click)="submit()"
                        [disabled]="selectedApplications.length === 0 || !customerData">
                        Process Transfer
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>